import { createSelector } from 'reselect';
export const makeSelectAvailableCosmetic = type => createSelector(state => state.cosmeticItemsConfigs.cosmeticConfigs, state => state.cosmeticAllInventory, (cosmeticConfigs, cosmeticInventory) => {
  if (!cosmeticConfigs) return {
    data: []
  };
  const userAvatarFrame = cosmeticInventory.data.filter(cosmetic => cosmetic.cosmeticInfo.type === type);
  const data = userAvatarFrame.map(cosmetic => {
    return { ...cosmetic,
      urlImage: cosmeticConfigs[cosmetic.cosmeticInfo.typeId].urlImage
    };
  });
  return {
    data: data
  };
});